(function () {
	'use strict';

	angular.module('widgets.supplychain')
		.service('deliveryScoreTrendService', deliveryScoreTrendService);

	deliveryScoreTrendService.$inject = ['$http', 'tableService'];

	function deliveryScoreTrendService($http, tableService) {
		return {
			getChartData: getChartData
		};

		function getChartData(filterService) {
			var factoryNdxString = filterService.getFactoryList();
			var url = '/api/2/factndx/' + factoryNdxString;
			url += '/SupplierPerformanceReport/DeliveryScoreBySupplier';
			url = addQueryParam(url,
				filterService.getFactoryList(), filterService.getQueryParamsObject(true), false);

			tableService.trackPageView('delivery-score-trend', factoryNdxString);

			return $http.get(url)
				.then(getChartDataComplete)
				.catch(getChartDataFailed);

			function getChartDataComplete(response) {
				return response.data;
			}
			function getChartDataFailed(error) {
				return error;
			}
		}
	}
})();
